module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "bk-footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_c('div', {
    staticClass: "copy-content min-width-center"
  }, [_c('img', {
    attrs: {
      "src": require("../images/common/footer-logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v("Copyright © 2012-" + _vm._s(_vm.year) + " Tencent. All Rights Reserved.  腾讯公司 版权所有")]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-content min-width-center clearfix"
  }, [_c('dl', {
    staticClass: "clearfix"
  }, [_c('dt', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("网站导航")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "http://bk.tencent.com/info#news"
    }
  }, [_vm._v("蓝鲸动态")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "http://bk.tencent.com/info#recruit"
    }
  }, [_vm._v("招聘信息")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "http://bk.tencent.com/info#laws"
    }
  }, [_vm._v("法律申明")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "http://bk.tencent.com/info#about"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "http://bbs.bk.tencent.com/"
    }
  }, [_vm._v("蓝鲸论坛")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "http://bk.tencent.com/school_edition/"
    }
  }, [_vm._v("蓝鲸校园")])])]), _vm._v(" "), _c('dl', {
    staticClass: "clearfix"
  }, [_c('dt', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("蓝鲸客服")]), _vm._v(" "), _c('dd', [_vm._v("客服 QQ：\n                "), _c('a', {
    attrs: {
      "href": "https://wpa1.qq.com/KziXGWJs?_type=wpa&qidian=true",
      "target": "_blank"
    }
  }, [_vm._v("800802001")])]), _vm._v(" "), _c('dd', [_vm._v("客服邮箱：\n                "), _c('a', {
    attrs: {
      "href": "mailto:contactus_bk@tencent.com"
    }
  }, [_vm._v("contactus_bk@tencent.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "qr_code"
  }, [_c('img', {
    attrs: {
      "src": require("../images/common/Qr_code.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language"
  }, [_vm._v("\n                    简体中文 "), _c('span', [_c('img', {
    attrs: {
      "src": require("../images/common/footer-select.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "language-choose"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("简体中文")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9e2753d2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/footer.vue
// module id = SWXp
// module chunks = 15